module.exports = __webpack_public_path__ + "media/images/icons/upload-8cc7f4dd01a7a892af316ecf32d426de.svg";